import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    root: {
        width: '42%',
    },
    text: {
        marginBottom: 24,
    },
});

export default styles;
